import { render } from "./Status.vue?vue&type=template&id=16274202&scoped=true&ts=true"
import script from "./Status.vue?vue&type=script&lang=ts"
export * from "./Status.vue?vue&type=script&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=16274202&lang=scss&scoped=true"

import exportComponent from "/src/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16274202"]])

export default __exports__